import CaseStudyPage from './CaseStudyPage';

export default CaseStudyPage;



// WEBPACK FOOTER //
// ./src/components/CaseStudyPage/index.js